import { nanoid } from 'nanoid';
import { POLL_PROTOTYPE_SCREEN as QuestionType } from '../../../../../poll';
import { assignProperties } from '../../../../schemaUtils';
import { config } from './PrototypeScreen.config';

export function generateQuestion(
  answers: QuestionType['data']['answers'] = [],
  overrides: Partial<QuestionType['data']> = {},
): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: 'Экран',
        answers,
        logicRules: [],
        image: undefined,
      },
      overrides,
    ),
  };
}
type AnswerType = QuestionType['data']['answers'][number];

/** Убирает указанные свойства из всех объектов-членов объединения */
export type SoftOmit<T, P extends keyof T> = T extends T ? Omit<T, P> : never;

export function generateAnswer(
  overrides: SoftOmit<AnswerType, 'id' | 'text'> & { id?: string; text?: string },
): AnswerType {
  return {
    id: nanoid(10),
    text: '',
    ...overrides,
  };
}
